class ModalWindow extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
        this.content = this.querySelector('.modal-window__content');
        this.newContent = this.content.cloneNode(true);
        this.modalWindow = document.querySelector('.modal-window');
        this.container = this.modalWindow.querySelector('.modal-window__container');
        this.modalButton = this.querySelector('.modal-window__button');
        this.closeButton = this.modalWindow.querySelector('.modal-window__close');

        
        this.modalButton.addEventListener('click', (e) => {
            if(this.content && this.modalWindow){
                this.newContent.removeAttribute('hidden');
                this.container?.querySelector('.modal-window__content')?.remove();
                this.container?.appendChild(this.newContent);
            }
            e.preventDefault();
            this.modalWindow.setAttribute('open', '')
        })

        this.modalWindow.addEventListener('click', (e) => {
            if(e.target === this.modalWindow) this.modalWindow.removeAttribute('open')
        })

        this.closeButton.addEventListener('click', () => {
            this.modalWindow.removeAttribute('open');
        })

    }
  }
  
  // Define the custom element
  customElements.define('modal-window', ModalWindow);
  